import environmentSettings from "../constants/environmentSettings";

export const CONTENT_URL = environmentSettings.contentManagementUrl;
export const CONTENT_TOKEN = environmentSettings.contentToken;
export const BANNER_CONTENT = "/api/banner-messages?populate=*";